import React from "react";

const VisitorList = () => {
    return (
        <div className="visitorList">
            {/* <span>VISITOR 1 SECTION</span> */}

            <div className="visitorSection">
                <ul>
                    <li>
                        <div className="vBox roll-in-blurred-bottom7">
                            <div className="vIcon"></div>
                            <div className="vNumber">
                                <span>1st</span><br />
                                <span>Visitor</span>
                            </div>
                            <div className="vInfo">
                                <p>TAN AH MENG</p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="vBox roll-in-blurred-bottom8">
                            <div className="vIcon"></div>
                            <div className="vNumber">
                                <span>2nd</span><br />
                                <span>Visitor</span>
                            </div>
                            <div className="vInfo">
                                <p>TAN AH TOCK</p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="vBox roll-in-blurred-bottom9">
                            <div className="vIcon"></div>
                            <div className="vNumber">
                                <span>3rd</span><br />
                                <span>Visitor</span>
                            </div>
                            <div className="vInfo">
                                <p>TAN AH SENG</p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="vBox roll-in-blurred-bottom10">
                            <div className="vIcon"></div>
                            <div className="vNumber">
                                <span>4th</span><br />
                                <span>Visitor</span>
                            </div>
                            <div className="vInfo">
                                <p>TAN AH LOCK</p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>

        </div>
    );
};
export default VisitorList